<template>
  <v-container fluid>
    <v-row dense>
      <v-col xs="12" sm="12" md="12" lg="12" xl="12">
        <!-- banner ad espansione-->
        <base-page-description-panel
          :title-path="getPageDescDetails.title"
          :title-params="getPageDescDetails.params"
          :text="getPageDescDetails.text"
          :needHtml="getPageDescDetails.needHtml"
        ></base-page-description-panel>
      </v-col>

      <v-col xs="12" sm="12" md="12" lg="12" xl="12">
        <v-card class="cardbg pa-0 mt-3" flat>
          <v-card-text class="pt-0">
            <v-row no-gutters>
              <!-- typeFilter -->
              <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="4" class="pr-2">
                <base-autocomplete-filter
                  v-model="typeFilter"
                  :items="notificationTypes"
                  label="typeFilter"
                  :isMultiple="true"
                  @onsearch="onChangeTypeFilter"
                  @onclear="onClearTypeFilter"
                  @onremoveselected="onRemoveSelectedTypeFilter"
                ></base-autocomplete-filter>
              </v-col>
              <!-- dateToUse -->
              <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="3">
                <base-range-date-picker-biz
                  :dateToUseValues="[]"
                  :hasDateToUse="false"
                  :dateToUse="''"
                  :storedDateRange="storedDateRange"
                  @onset="onSetDateOptionsFilter"
                  @onsearch="onChangeDateOptionsFilter"
                ></base-range-date-picker-biz>
              </v-col>
            </v-row>
          </v-card-text>

          <!--Results part-->
          <span v-if="existNotifications">
            <v-card-title class="mt-0 pt-0">
              <span
                class="title font-weight-bold"
                v-if="numberOfNotifications >= 1"
              >
                <span v-if="searchCriteriaResult">
                  <span class="subtitle-1 font-weight-medium">
                    <span
                      >{{
                        $t("notificationsCenter.searchResult.subtitle-pt1")
                      }}&nbsp;</span
                    >
                    <span class="result"
                      >{{ numberOfNotifications }}&nbsp;</span
                    >
                    <span
                      >{{
                        $t("notificationsCenter.searchResult.subtitle-pt2")
                      }}&nbsp;</span
                    >
                    <span class="result">{{ searchCriteriaResult }}</span>
                  </span>
                </span>
                <span v-else>
                  <span class="subtitle-1 font-weight-medium">
                    <span
                      >{{
                        $t("notificationsCenter.searchResult.subtitle-pt3")
                      }}&#58;&nbsp;</span
                    >
                    <span class="result"
                      >{{ numberOfNotifications }}&nbsp;</span
                    >
                    <span>{{
                      $t("notificationsCenter.searchResult.subtitle-pt4")
                    }}</span>
                  </span>
                </span>
              </span>
            </v-card-title>
          </span>
          <!--END Results part-->

          <!--No Results part-->
          <span v-if="noexistNotifications">
            <v-card-title class="mt-0 pt-0">
              <span
                class="title font-weight-bold"
                v-if="numberOfNotifications == 0"
              >
                <span v-if="searchCriteriaResult">
                  <v-icon left color="primary">fas fa-times-circle</v-icon>
                  <span class="subtitle-1 font-weight-medium">
                    <span
                      >{{
                        $t("notificationsCenter.searchResult.subtitle-pt1")
                      }}&nbsp;</span
                    >
                    <span class="result"
                      >{{ numberOfNotifications }}&nbsp;</span
                    >
                    <span
                      >{{
                        $t("notificationsCenter.searchResult.subtitle-pt2")
                      }}&nbsp;</span
                    >
                    <span class="result">{{ searchCriteriaResult }}</span>
                  </span>
                </span>
                <span v-else>
                  <span class="subtitle-1 font-weight-medium">
                    <span
                      >{{
                        $t("notificationsCenter.searchResult.subtitle-pt3")
                      }}&#58;&nbsp;</span
                    >
                    <span class="result"
                      >{{ numberOfNotifications }}&nbsp;</span
                    >
                    <span>{{
                      $t("notificationsCenter.searchResult.subtitle-pt4")
                    }}</span>
                  </span>
                </span>
              </span>
            </v-card-title>
          </span>
          <!--END No Results part-->

          <!--<v-card-title class="mt-0 pt-0">
            <span v-if="searchCriteriaResult">
              <span class="subtitle-1 font-weight-medium">
                <span
                  >{{
                    $t("notificationsCenter.searchResult.subtitle-pt1")
                  }}&nbsp;</span
                >
                <span class="result">{{ numberOfNotifications }}&nbsp;</span>
                <span
                  >{{
                    $t("notificationsCenter.searchResult.subtitle-pt2")
                  }}&nbsp;</span
                >
                <span class="result">{{ searchCriteriaResult }}</span>
              </span>
            </span>
            <span v-else>
              <span class="subtitle-1 font-weight-medium">
                <span
                  >{{
                    $t("notificationsCenter.searchResult.subtitle-pt3")
                  }}&#58;&nbsp;</span
                >
                <span class="result">{{ numberOfNotifications }}&nbsp;</span>
                <span>{{
                  $t("notificationsCenter.searchResult.subtitle-pt4")
                }}</span>
              </span>
            </span>
          </v-card-title>-->

          <v-card-text class="pt-0">
            <v-row dense>
              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="6"
                lg="6"
                xl="6"
                v-for="(notification, i) in notifications"
                :key="i"
              >
                <notification-list-item
                  :notification="notification"
                  @navigateto="navigateToExternalPage"
                ></notification-list-item>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col sm="12" text-sm-center class="pt-4">
                <v-pagination
                  v-if="existNotifications"
                  :total-visible="7"
                  limit
                  v-model="page"
                  :length="Math.ceil(numberOfNotifications / 10)"
                ></v-pagination>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BaseAutocompleteFilter from "./BaseAutocompleteFilter";
import BaseRangeDatePickerBiz from "./BaseRangeDatePickerBiz";
import NotificationListItem from "./NotificationsListItem";
import dayjs from "dayjs";

export default {
  components: {
    BaseAutocompleteFilter,
    BaseRangeDatePickerBiz,
    NotificationListItem
  },
  data() {
    return {};
  },
  async created() {
    await this.$store.dispatch("notifications/getNotificationTypes");
    await this.$store.dispatch("notifications/reloadNotifications");
  },
  computed: {
    getPageDescDetails() {
      let config = {};
      config.title = "notificationsCenter.pageTitle";
      config.params = {};
      config.needHtml = false;
      config.text = "notificationsCenter.pageText";
      return config;
    },
    notificationTypes() {
      return this.$store.getters["notifications/getNotificationTypes"];
    },
    dateRange() {
      return this.$store.getters["notifications/getDateRange"];
    },
    typeFilter: {
      get: function () {
        return this.$store.getters["notifications/getTypeFilter"];
      },
      set: function (value) {
        /**
         * if the component has the 'isMultiple = true' property, the
         * incoming value is an array of values, otherwise is a single value
         */
        if (Array.isArray(value)) {
          this.$store.dispatch("notifications/updateTypeFilterField", value);
        } else {
          let filter = [];
          filter.push(value);
          this.$store.dispatch("notifications/updateTypeFilterField", filter);
        }
      }
    },
    page: {
      get() {
        return this.$store.getters["notifications/getPage"] || 1;
      },
      set(val) {
        this.$store.dispatch(
          "notifications/updatePageAndReloadNotifications",
          Number(val) || 0
        );
      }
    },
    numberOfNotifications() {
      return this.$store.getters["notifications/getNumberOfNotifications"];
    },
    notifications() {
      return this.$store.getters["notifications/getNotifications"];
    },
    existNotifications() {
      return this.notifications && this.notifications.length > 0;
    },
    noexistNotifications() {
      return this.notifications && this.notifications.length == 0;
    },
    searchCriteriaResult() {
      return this.$store.getters["notifications/getSearchCriteriaResult"];
    },
    storedDateRange() {
      if (this.dateRange) {
        let df = this.dateRange.start ? this.dateRange.start : null;
        let dt = this.dateRange.end ? this.dateRange.end : null;
        if (df || dt) {
          let dr = {
            start: null,
            end: null
          };
          if (df) {
            if (df.includes("/")) {
              const [day, month, year] = df.split("/");
              df = `${year}-${month}-${day}`;
            }
            dr.start = this.constructDate(dayjs(df).toDate());
          }
          if (dt) {
            if (dt.includes("/")) {
              const [day, month, year] = dt.split("/");
              dt = `${year}-${month}-${day}`;
            }
            dr.end = this.constructDate(dayjs(dt).toDate());
          }
          return dr;
        }
      }
      return null;
    }
  },
  methods: {
    constructDate(date) {
      return new Date(
        Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0)
      );
    },
    onChangeTypeFilter(value) {
      /**
       * if the component has the 'isMultiple = true' property, the
       * incoming value is an array of values, otherwise is a single value
       */
      if (Array.isArray(value)) {
        if (value && value.length > 0) {
          this.$store.dispatch(
            "notifications/updateTypeFilterFieldAndReloadNotifications",
            [...value]
          );
        }
      } else {
        let filter = [];
        filter.push(value);
        this.$store.dispatch(
          "notifications/updateTypeFilterFieldAndReloadNotifications",
          filter
        );
      }
    },
    onClearTypeFilter() {
      this.$store.dispatch(
        "notifications/updateTypeFilterFieldAndReloadNotifications",
        []
      );
    },
    onRemoveSelectedTypeFilter(value) {
      this.$store.dispatch(
        "notifications/updateTypeFilterFieldWhenRemovedAndReloadNotifications",
        value
      );
    },
    onSetDateOptionsFilter(payload) {
      this.$store.dispatch(
        "notifications/updateDateOptionsFilterField",
        payload
      );
    },
    onChangeDateOptionsFilter(payload) {
      this.$store.dispatch(
        "notifications/updateDateOptionsFilterFieldAndReloadNotifications",
        payload
      );
    },
    navigateToExternalPage(notificationType, appointmentId, billId) {
      if (notificationType === "APPOINTMENT") {
        this.$router.push({
          name: "_appointmentManagement",
          params: { id: appointmentId }
        });
      }
      if (notificationType === "BILL") {
        this.$store.commit("bills/SET_ACTIVE_BILL_ID", billId);
        this.$router.push({
          name: "_billDetails",
          params: { id: billId }
        });
      }
    }
  }
};
</script>

<style scoped>
.theme--light.v-pagination >>> button {
  box-shadow: unset;
  background: transparent;
  padding: 0 10px;
  color: var(--primary) !important;
  font-weight: bold;
  margin: 0;
  min-width: unset;
}
.theme--light.v-pagination >>> button.v-pagination__item--active {
  color: white !important;
}
.v-pagination >>> .v-icon {
  color: var(--primary) !important;
  font-size: 18px;
}
.result {
  color: var(--secondary) !important;
  font-weight: bold;
  font-style: normal;
  font-size: 18px;
}
</style>
